import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MoonLoader',
    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        color: {
            type: String,
            default: '#5dc596',
        },
        size: {
            type: String,
            default: '60px',
        },
        margin: {
            type: String,
            default: '2px',
        },
        radius: {
            type: String,
            default: '100%',
        },
        customClass: {
            type: String,
            default: '',
        },
    },
    setup(__props) {
        const props = __props;
        const spinnerStyle = ref({
            height: props.size,
            width: props.size,
            borderRadius: props.radius,
        });
        const moonSize = computed(() => {
            return parseFloat(props.size) / 7;
        });
        const spinnerMoonStyle = computed(() => {
            return {
                height: moonSize.value + 'px',
                width: moonSize.value + 'px',
                borderRadius: props.radius,
            };
        });
        const animationStyle2 = computed(() => {
            return {
                top: parseFloat(props.size) / 2 - moonSize.value / 2 + 'px',
                backgroundColor: props.color,
            };
        });
        const animationStyle3 = computed(() => {
            return {
                border: moonSize.value + 'px solid ' + props.color,
            };
        });
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["v-spinner", __props.customClass])
            }, [
                _createElementVNode("div", {
                    class: "v-moon v-moon1",
                    style: _normalizeStyle(spinnerStyle.value)
                }, [
                    _createElementVNode("div", {
                        class: "v-moon v-moon2",
                        style: _normalizeStyle([spinnerMoonStyle.value, animationStyle2.value])
                    }, null, 4),
                    _createElementVNode("div", {
                        class: "v-moon v-moon3",
                        style: _normalizeStyle([spinnerStyle.value, animationStyle3.value])
                    }, null, 4)
                ], 4)
            ], 2)), [
                [_vShow, __props.loading]
            ]);
        };
    }
});
